var slider;

slider = function() {
  var $, Swiper, headSlider, interleaveEffect, interleaveOffset, swiperOptions;
  Swiper = require('swiper');
  $ = require('jquery');
  interleaveOffset = -.5;
  interleaveEffect = {
    onProgress: function(swiper, progress) {
      var i, innerTranslate, slide, translate;
      i = 0;
      while (i < swiper.slides.length) {
        slide = swiper.slides[i];
        translate = void 0;
        innerTranslate = void 0;
        progress = slide.progress;
        if (progress > 0) {
          translate = progress * swiper.width;
          innerTranslate = translate * interleaveOffset;
        } else {
          innerTranslate = Math.abs(progress * swiper.width) * interleaveOffset;
          translate = 0;
        }
        $(slide).css({
          transform: 'translate3d(' + translate + 'px,0,0)'
        });
        $(slide).find('.page-banner__slide-inner').css({
          transform: 'translate3d(' + innerTranslate + 'px,0,0)'
        });
        i++;
      }
    },
    onTouchStart: function(swiper) {
      var i;
      i = 0;
      while (i < swiper.slides.length) {
        $(swiper.slides[i]).css({
          transition: ''
        });
        i++;
      }
    },
    onSetTransition: function(swiper, speed) {
      var i;
      i = 0;
      while (i < swiper.slides.length) {
        $(swiper.slides[i]).find('.page-banner__slide-inner').andSelf().css({
          transition: speed + 'ms'
        });
        i++;
      }
    }
  };
  swiperOptions = {
    speed: 1000,
    grabCursor: true,
    watchSlidesProgress: true,
    keyboardControl: true,
    slidePerView: 1,
    loop: true,
    autoplay: {
      delay: 5000
    },
    pagination: {
      el: '#headpagination'
    }
  };
  return headSlider = new Swiper('.swiper-container#headslider', swiperOptions);
};

module.exports = slider;
